import React from 'react'
import T from 'prop-types'
import { Button, CircularProgress, Collapse, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { BASE_FILE_UPLOAD_EXTENSIONS } from 'hooks/useInputOutput'

import UploadedFileName from './UploadedFileName'

export default function UploadBar({
  id,
  fileName,
  accept = BASE_FILE_UPLOAD_EXTENSIONS,
  uploadButtonLabel,
  selectFileButtonLabel,
  handleSelectFile = () => {},
  uploaded,
  hideFileName,
  readOnly,
  loading = false,
  ingestLabel,
  onIngest,
}) {
  const { t } = useTranslation()

  return (
    <Stack direction="row" alignItems="center">
      {uploaded && !hideFileName && (
        <UploadedFileName fileName={fileName} uploaded={uploaded} />
      )}
      <Collapse orientation="horizontal" in={loading}>
        <div style={{ marginLeft: 4, marginRight: 4 }}>
          <CircularProgress size={20} />
        </div>
      </Collapse>
      <label htmlFor={`${id || ''}${id ? '-' : ''}upload-file`}>
        <input
          accept={accept.toString()}
          id={`${id || ''}${id ? '-' : ''}upload-file`}
          type="file"
          disabled={readOnly}
          style={{ display: 'none' }}
          onChange={handleSelectFile}
        />
        <Button
          color={uploaded ? 'secondary' : 'primary'}
          variant="contained"
          component="span"
          disabled={readOnly}
        >
          {uploaded
            ? uploadButtonLabel || t(`common.form.uploadButton`)
            : selectFileButtonLabel || t(`common.form.selectFileButton`)}
        </Button>
        {ingestLabel && onIngest && (
          <Button
            data-testid="ingest-button"
            color={uploaded ? 'secondary' : 'primary'}
            variant="contained"
            component="span"
            disabled={readOnly}
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              onIngest()
            }}
          >
            {ingestLabel}
          </Button>
        )}
      </label>
    </Stack>
  )
}

UploadBar.propTypes = {
  id: T.string,
  fileName: T.string,
  accept: T.array,
  uploadButtonLabel: T.string,
  selectFileButtonLabel: T.string,
  handleSelectFile: T.func,
  uploaded: T.bool,
  hideFileName: T.bool,
  readOnly: T.bool,
  loading: T.bool,
}
